
import { SeguimentoFactura } from "@/model/Factura";
import { FacturaService } from "@/services/FacturaService";
import { Constantes } from "@/Util/Constantes";
import { HeaderTemplate, Utilidades } from "@/Util/Utilidades";
import Vue from "vue";

export default Vue.extend({
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      headers: new Array<Object>() as Array<HeaderTemplate>,
      busqueda: "" as string,
      loading: false as boolean,
      seguimientos: new Array<Object>() as Array<SeguimentoFactura>,
      tituloModal: "" as string, 
      id_factura:"" as string,
    };
  },
  async mounted() {
    this.montarHeaders();
  },
  methods: {    
    montarHeaders() {
      this.headers = new Array<HeaderTemplate>();

      this.headers.push(
        Utilidades.nuevoHeader({
          text: "Fecha",
          value: "fecha_sistema",
          fecha_hora: true
        })
      );
      this.headers.push(
        Utilidades.nuevoHeader({
          text: "Usuário",
          value: "responsable",
        })
      );
      
      this.headers.push(
        Utilidades.nuevoHeader({
          text: "Tipo",
          value: "nombre_tipo_seguimiento",
        })
      );

      this.headers.push(
        Utilidades.nuevoHeader({ text: "Texto", value: "texto" })
      );
    },
    async cargarSeguimiento(id_factura, titulo) {     
      this.loading = true;
      this.seguimientos = [];
      this.tituloModal = titulo;

      await FacturaService.getSeguimentoFacturaAsync(id_factura)
        .then(x => {
            this.seguimientos = x.data;            
        })
        .catch(y => {
          Utilidades.Message({ message: Constantes.ERROR_CARGAR_DATOS, error: true }) 
        })
    
      this.loading = false;
    },
    //#endregion
  },
  
});
